module.exports = "/_next/static/images/91a7efc6fe406fc04a7c459066c98745-hero-variant-a-desktop.jpg.webp";